// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const decidueye: PokeData = {
  "id": 724,
  "name": "decidueye",
  "height": 16,
  "weight": 366,
  "base_experience": 239,
  "types": [
    PokeType.GRASS,
    PokeType.GHOST
  ],
  "api_moves": [
    "fury-attack",
    "tackle",
    "growl",
    "peck",
    "razor-leaf",
    "spite",
    "foresight",
    "synthesis",
    "feather-dance",
    "astonish",
    "leaf-blade",
    "pluck",
    "u-turn",
    "sucker-punch",
    "brave-bird",
    "nasty-plot",
    "shadow-sneak",
    "leaf-storm",
    "ominous-wind",
    "phantom-force",
    "spirit-shackle",
    "leafage"
  ],
  "moves": [
    "tackle",
    "growl",
    "peck",
    "razor-leaf",
    "synthesis",
    "brave-bird",
    "shadow-sneak",
    "phantom-force",
    "flower-rush",
    "curse",
    "poltergeist",
    "soul-sacrifice",
    "leaf-tornado"
  ],
  "evolution_chain": {
    "id": 374,
    "item": null,
    "species": [
      {
        "name": "rowlet",
        "order": 722,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dartrix",
        "order": 723,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 722,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "decidueye",
        "order": 724,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 723,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 127,
    "speed": 108,
    "ability_power": 165
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
